/**
 * @file
 * Megamenu scripts.
 */

const $megamenu = $('.mega-menu-wrapper', context);
$megamenu.once('megamenu-class-slideshow').each(function() {
  const $this = $(this);

  // Finds megamenu and adds class to parent menu item.
  const $parentLink = $this.parent('.menu-item');
  $parentLink.addClass('is-megamenu');

  // Collections slideshow.
  const $slideshowContainer = $this.find('.simple-mega-menu');
  const $slideshowWrapper = $this.find(
    '.field-name-field-megamenu-item > .field-items'
  );

  if ($slideshowContainer.hasClass('simple-mega-menu-1')) {
    $parentLink.addClass('megamenu-type-1');
  } else if ($slideshowContainer.hasClass('simple-mega-menu-2')) {
    $parentLink.addClass('megamenu-type-2');
  }

  if ($slideshowContainer.hasClass('cpl-mega-menu-slideshow')) {
    const megamenuStyle = $slideshowContainer.attr('data-megamenu-style');
    let slides;

    // TODO: slideshow will also be used in style 2 with different settings
    if (megamenuStyle === 2) {
      slides = 4;
    } else if (megamenuStyle === 3) {
      slides = 4;
    } else if (megamenuStyle === 4) {
      slides = 5;
    }

    const options = {
      infinite: true,
      autoplay: false,
      slidesToShow: slides,
      slidesToScroll: slides,
      dots: true,
      arrows: false,
    };

    $slideshowWrapper.slick(options);
  }
});

// Menu that opens on click
const $clickMenu = $('.cpl-mega-menu-click', context);
$clickMenu.once('click-menu').each(function() {
  const $this = $(this);

  // Finds megamenu and adds class to parent menu item.
  $this.parents('.menu-item').addClass('is-clickable-megamenu');

  // Close the menu.
  $this.find('.close-button').click(event => {
    event.preventDefault();
    $('.is-clickable-megamenu').removeClass('is-opened');
  });
});

// Open the menu.
const $clickOpenMenu = $('.is-clickable-megamenu > a', context);
$clickOpenMenu.once('click-open-menu').each(function() {
  const $this = $(this);

  $this.click(function(event) {
    event.preventDefault();
    const $parentMenu = $(this).parent();

    if (!$parentMenu.hasClass('is-opened')) {
      $('.is-clickable-megamenu').removeClass('is-opened');
      $parentMenu.addClass('is-opened');
    } else {
      $('.is-clickable-megamenu').removeClass('is-opened');
    }
  });
});

// Ad slideshow for Megamenu Style 2
const $adSlideshow = $('.megamenu-slideshow-block', context);
$adSlideshow.once('megamenu-ad-slideshow').each(function() {
  $(this)
    .find('.field-name-field-menu-content-ref > .field-items')
    .slick({
      infinite: true,
      autoplay: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
    });
});

// Vertical tabs for megamenu type 2, style 2.
const $verticalTabs = $(
  '.cpl-mega-menu-style-2 .paragraph--type--megamenu-menu > .menu',
  context
);
$verticalTabs.once('megamenu-vertical-tabs').each(function() {
  const $menu = $(this);
  const random = btoa(Math.random())
    .substr(5, 5)
    .toLowerCase();

  // Tabs content
  $menu.find('li > ul').each(function(index, el) {
    const $tabContent = $(el);

    if (index === 0) {
      $tabContent.addClass('is-tab-active');
    }

    $tabContent.attr('id', `tab-${index}-${random}`).addClass('tab-content');
    $tabContent.prepend('<div class="title"></div>');
  });

  // Tabs content items
  $menu.find('li > ul > li').each(function(index, el) {
    const $tabContentItem = $(el);

    $tabContentItem.find('a').each(function() {
      const description = $(this).attr('title');

      if (description) {
        $(this).append('<div class="description"></div>');
        $tabContentItem.find('.description').prepend(description);
      }
    });
  });

  // Tabs headers
  $menu.find('> li > a').each(function(index, el) {
    const $tabHeader = $(el);
    const title = $tabHeader.text();

    if (index === 0) {
      $tabHeader.addClass('is-tab-active');
    }

    if ($tabHeader.next('ul').length) {
      $tabHeader
        .attr('data-tab-open', `tab-${index}-${random}`)
        .addClass('tab-header');

      $(`#tab-${index}-${random} .title`).text(title);
    }

    $tabHeader.click(function(event) {
      event.preventDefault();
      const id = $(this).attr('data-tab-open');

      if (id !== undefined) {
        // Adds active class to tab content.
        $menu.find('.tab-content').removeClass('is-tab-active');
        $(`#${id}`).addClass('is-tab-active');

        // Adds active class to tab header.
        $menu.find('> li > a').removeClass('is-tab-active');
        $tabHeader.addClass('is-tab-active');
      }
    });
  });
});
